import { IconButton, TextField, Tooltip } from "@mui/material";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useVideo } from "../../../../../context/juno/VideoContext";
import { ImageUploadMode, getImageUploadMode } from "../../../../../utils/validation/videoValidation";
import { ColumnBox, RowBox, RowCenteredBox } from "../../../../../utils/styledBox";
import AspectRatioIcons from "../AspectRatioIcons";
import ImageUpload from "../ImageUpload";
import { Info, SwapVert as SwapVertIcon } from "@mui/icons-material";
import ModelVersionSelectBox from "../ModelVersionSelectBox";

const ParamsFramepack = () => {
  const { t } = useTranslation();
  const {
    menu,
    modelVersion,
    updateParams,
    image1,
    setImage1,
    image2,
    setImage2,
    duration,
    guidanceScales,
    negativePrompt,
    setNegativePrompt,
  } = useVideo();
  const aspectRatio = ["16:9", "9:16"];

  const durationMarks = [
    { value: 5, label: "5s" },
    { value: 30, label: "30s" },
    { value: 60, label: "60s" },
  ];

  // 画像入れ替え処理
  const replaceImage = () => {
    const tmp = image1;
    setImage1(image2);
    setImage2(tmp);
  };

  return (
    <ColumnBox sx={{ gap: 4 }}>
      <ColumnBox>
        {/* モデルバージョン */}
        <Typography variant="body2" mb={1}>
          {t("juno.video.ai.model")}
        </Typography>
        <ModelVersionSelectBox onChange={(value) => updateParams("FRAMEPACK", "modelVersion", value)} />
      </ColumnBox>

      <ColumnBox>
        {/* Duration */}
        <Typography variant="body2" mb={1}>
          {t("juno.video.params.duration")}
        </Typography>
        <Slider
          aria-label="duration"
          marks={durationMarks}
          min={5}
          max={60}
          step={1}
          valueLabelDisplay="auto"
          value={duration.FRAMEPACK}
          onChange={(_, value) => updateParams("FRAMEPACK", "duration", value)}
        />
      </ColumnBox>

      {menu === "i2v" &&
        (() => {
          const uploadMode = getImageUploadMode("FRAMEPACK", modelVersion.FRAMEPACK, menu);
          switch (uploadMode) {
            case ImageUploadMode.DUAL:
              return (
                <ColumnBox sx={{ justifyContent: "center" }}>
                  <Typography variant="body2" mb={1}>
                    {t("juno.video.params.upload")} - FIRST
                  </Typography>
                  <ImageUpload image={image1} setImage={setImage1} />

                  <RowCenteredBox sx={{ my: 2 }}>
                    <IconButton onClick={replaceImage}>
                      <SwapVertIcon />
                    </IconButton>
                  </RowCenteredBox>

                  <Typography variant="body2" mb={1}>
                    {t("juno.video.params.upload")} - LAST
                  </Typography>
                  <ImageUpload image={image2} setImage={setImage2} />
                </ColumnBox>
              );
            case ImageUploadMode.SINGLE:
            default:
              return (
                <ColumnBox sx={{ justifyContent: "center" }}>
                  <Typography variant="body2" mb={1}>
                    {t("juno.video.params.upload")}
                  </Typography>
                  <ImageUpload image={image1} setImage={setImage1} />
                </ColumnBox>
              );
          }
        })()}

      <ColumnBox>
        {/* aspect */}
        <AspectRatioIcons aspectRatioList={aspectRatio} />
      </ColumnBox>

      <ColumnBox>
        <RowBox sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="body2" mb={1}>
            {t("juno.video.params.guidanceScale")}
          </Typography>
          <Tooltip title={t("juno.video.params.guidanceScaleHelp")} placement="top">
            <IconButton size="small">
              <Info fontSize="small" />
            </IconButton>
          </Tooltip>
        </RowBox>
        <Slider
          value={guidanceScales["FRAMEPACK"]}
          onChange={(_, value) => updateParams("FRAMEPACK", "guidanceScale", value)}
          min={1}
          max={32}
          step={1}
          valueLabelDisplay="auto"
          marks={[
            { value: 1, label: "1" },
            { value: 10, label: "Default" },
            { value: 20, label: "20" },
            { value: 32, label: "32" },
          ]}
        />
      </ColumnBox>

      <ColumnBox>
        <Typography variant="body2" mb={1}>
          {t("juno.video.params.negativePrompt")}
        </Typography>
        <TextField
          value={negativePrompt}
          onChange={(e) => setNegativePrompt(e.target.value)}
          variant="standard"
          fullWidth
          multiline
          maxRows={4}
          inputProps={{ maxLength: 500 }}
        />
      </ColumnBox>
    </ColumnBox>
  );
};
export default ParamsFramepack;
